import styled from '@emotion/styled'

// make the export the default for the file

export const FilterOptionsStyled = styled.div`
  width: 13rem;
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-bottom: 1rem;

  ul {
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.25rem;
  }
  li {
    margin-bottom: 0.25rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: 100%;
    cursor: pointer;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    line-height: 1;
    &:hover {
      background-color: #f3f3f2;
    }
    &.selected {
      background-color: #e7e6e4;

      &:hover {
        background-color: #e7e6e4;
      }
    }
  }
`
